module.exports = __webpack_public_path__ + "img/logo.63b0bc9d.png";